import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { observable, action, runInAction, toJS, computed, makeObservable } from "mobx";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { API } from "General/API";

export class EmailInboxRuleStore extends CoreStore {
  data: API_MailInboxRule[] = [];
  actionState: StoreState = "RAW";

  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      actionState: observable,
      clear: action,
      list: computed,
      fetch: action.bound,
    });
  }

  clear() {
    this.data = [];
    this.actionState = "RAW";
  }

  url(ruleId?: number) {
    if (ruleId) {
      return API_URL.PROJECT_INBOXES.getMailRule(projectsDataStore.projectId, ruleId);
    }
    return API_URL.PROJECT_INBOXES.getMailRules(projectsDataStore.projectId);
  }

  @handleStoreState()
  async fetch() {
    try {
      const response = await API.getData<API_MailInboxRule[]>(this.url());
      runInAction(() => {
        this.data = response;
      });
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxRuleStore>("actionState")
  async deleteItem(ruleId: number) {
    try {
      await API.deleteData(this.url(ruleId));
      this.fetch();
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxRuleStore>("actionState")
  async editItem(ruleId: number, values: API_MailInboxRule) {
    try {
      const response = await API.editData(this.url(ruleId), values);
      this.fetch();
      return response;
    } catch (error) {
      throw error;
    }
  }

  @handleStoreState<EmailInboxRuleStore>("actionState")
  async createItem(values: API_MailInboxRule) {
    try {
      const response = await API.newData(this.url(), values);
      this.fetch();
      return response;
    } catch (error) {
      throw error;
    }
  }

  getItem(ruleId: number) {
    return this.data.find((item) => item.id === ruleId);
  }

  get list() {
    return toJS(this.data);
  }
}

export const emailInboxRuleStore = new EmailInboxRuleStore();
